<template>
<!-- SECTION BANNER -->
  <section class="banner" id="top">
    <div class="col-text">
      <h1>Rivha est un studio de pilates spécialisé dans les séances privées et sur-mesure à Saint-Rémy-de-Provence dans la région des Alpilles.</h1>
      <p>Le studio Rivha se distingue par son équipement de pointe et ses exercices avant-gardistes.</p>
      <p>Son cadre privilégié et discret procure une atmosphère sereine et intimiste, propice à la concentration et à la symbiose entre le corps et l'esprit. </p>

    </div>
    <div class="col-banner"></div>
  </section>
  <!-- SECTION COMMUNICATION -->
  <section class="main">
    <div class="row">
      <div class="col-60">
        <img src="./../assets/image_section1.png" alt="communication" class="section-img" />
      </div>
      <div class="col-40 section-text">
        <h2>La Communion<br /><span>du corps et de l'esprit</span></h2>
        <p>Prendre conscience de son corps, retrouver une harmonie, reprendre le contrôle de ses mouvements, de son souffle…</p>
        <p>La santé mentale et physique passe par une connaissance de soi et de son corps. C’est exactement ce que le studio Rivha Pilates propose.</p>
        <p>Cette variante de la discipline de base invite chacun à retrouver une meilleure posture au moyen d’exercices profonds et revitalisants pour le dos et l’ensemble du corps.</p>
        <p>En travaillant le Pilates en douceur, les muscles sont déliés, les articulations assouplies et le métabolisme retrouve toute sa vitalité. Retrouver cet équilibre qui manque souvent à notre quotidien dont le rythme a perdu son sens organique.</p>
      </div>
    </div>
  </section>
  <!-- SECTION PARTICULARITES -->
  <section class="main section-reverse">
    <div class="row">
      <div class="col-60">
        <img src="./../assets/image_section2.png" alt="particularites" class="section-img" />
      </div>
      <div class="col-40 section-text">
        <h2>Les particularités<br /><span>du studio Rivha Pilates</span></h2>
        <p>Le studio Rivha se distingue par son équipement de pointe et ses exercices avant-gardistes. Chaque séance est une parenthèse sur-mesure, pensée et modulée avec précision pour répondre spécifiquement aux attentes et aux besoins singuliers de chaque individu. L'attention est portée sur la technique et la posture, tout en développant l'endurance et la force pour retrouver sa paix intérieure et renforcer son corps.</p>
        <p>Adaptés aux débutants comme aux pratiquants confirmés, les séances que dispense Rivha Pilates allient exercices de respiration, positions et machines pour un renforcement musculaire et remédient à des maux passagers et chroniques.</p>
        <p>Rivha Pilates s’adresse également aux femmes enceintes et jeunes mamans qui cherchent à se réapproprier leur corps et leur métabolisme. Le temps d’une séance individuelle à l’abri des regards, nous ouvrons une parenthèse pour prendre soin de vous à l’aide d’un programme personnalisé.</p>
      </div>
    </div>
  </section>
  <!--SECTION PROGRAMME -->
  <section class="section-program"  id="cours">
    <div class="main">
      <h2>Séances privées</h2>
      <program></program>
      <p class="section-en">SESSIONS AVAILABLE IN FRENCH OR IN ENGLISH</p>
    </div>
  </section>

  <Gallery />

  <!-- SECTION COURS -->
  <section class="section-center section-cours" >
    <div class="main">
      <h2>Rivha Pilates<br /><span>Fondé par Roxane</span></h2>
        <div class="row">
        <div class="col-50 section-text">
          <p>
            En tant que danseuse ayant découvert le pilates en 2010, la synergie entre ces deux disciplines s'est naturellement imposée comme une vocation. Diplômée de la méthode <a href="https://www.merrithew.com/" target="_blank">Stott Pilates Merrithew®</a> leader mondial et formée auprès du centre de formation pionnier en France, <a href="https://www.biopilates.fr/" target="_blank">Biopilates</a>, fondé par Caroline Berger de Fémynie, j’ai approfondi mes connaissances en anatomie fonctionnelle et biomécanique, en myologie et ostéologie.
          </p>
          <p>
            Cette expertise me permet d'offrir un accompagnement personnalisé et efficace à ceux qui aspirent à renouer leur vitalité et leur bien-être physique.
          </p>
        </div>
        <div class="col-50 section-text">
          <p>Au programme de mes séances, il y a avant tout de la bienveillance et du partage. Au-delà de la forme physique, je vous aide aussi à réapprendre à respirer, à reprendre le contrôle sur votre corps, ses sensations et ses émotions. De nouveau ou pour la première fois, dans l’intimité du Rivha Studio, nous travaillerons les postures et exercices fondamentaux du Pilates avec les accessoires adéquats & les machines <a href="https://www.merrithew.com/for-businesses" target="_blank">Merrithew®</a> en toute sécurité et à votre rythme.</p>
        </div>
      </div>
    </div>
  </section>
  <!-- SECTION COURS -->
  <section class=" main section-reverse">
    <div class="row">
      <div class="col-60 col-video">
        <video autoplay muted loop height="800">
          <source src="./../assets/clip_website_2.mp4"  type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="col-40 section-text">
        <h2>Une méthode singulière<br /><span>associée à une technologie de pointe</span></h2>
        <p>La méthode Pilates est une traduction de millénaires d’exercices et de rituels destinés au bien-être de l’esprit comme du corps, dans le respect de votre condition. </p>
        <p>Rivha Studio est muni de Reformer<sup>TM</sup>, Stability Chair<sup>TM</sup>, Stability Barre<sup>TM</sup>, Arc Barrels<sup>TM</sup> & Cadillac<sup>TM</sup> ainsi que tous les accessoires <a href="https://www.merrithew.com/" target="_blank">Merrithew®</a></p>
        <p>Ces équipements <a href="https://www.merrithew.com/" target="_blank">Merrithew®</a> sont dédiés à faciliter les exercices de Pilates, améliorer votre mobilité, renforcer vos muscles profonds, redonner du tonus et délier vos articulations. Tout en douceur et en sécurité, nous évoluons de concert, séance après séance.</p>
      </div>
    </div>
  </section>

  
  <!-- SECTION CONTACT -->
  <section class="section-center section-contact" id="contact">
    <div class="main">
      <h2>Contact</h2>
      <p>Découvrez l’univers de Rivha Studio </p>
      <contact-form></contact-form>
    </div>
  </section>

  <book-modal 
    v-if="displayBook"
    v-on:closeModal="displayBook = false"
  >
  </book-modal>

</template>

<script>
import ContactForm from "./../components/ContactForm.vue";
import Program from "./../components/Program.vue";
import BookModal from "./../components/BookModal.vue";
import Gallery from "../components/Gallery.vue";

export default {
  name: "Home",
  components : {
    ContactForm,
    Program,
    BookModal,
    Gallery
  },
  data() {
    return {
      displayBook : false
    }
  }

}
</script>

<style scoped lang="scss">
@import "./../scss/variables.scss";

.row {
  width:100%;
  display: flex;
  align-items: center;
  margin-bottom:80px;
  margin-top: 80px;
}

.col-60 {
  width:58%;
  margin-right: 2%;
}

.section-text a {
  text-decoration:none;
  color:$mainColor;
}

.section-text a:hover {
  text-decoration: underline;
}

.col-40 {
  width: 40%;
}

.col-50 {
  width:50%;
}

.banner {
  height:100vh;
  display: flex;
  align-items: center;
}

.col-text {
  width:50%;
  background-image:url('./../assets/bg_header.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height:100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.col-banner{
  width:50%;
  background-image:url('./../assets/header.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height:100vh;
}

.banner p , .banner h1{
  font-size:22px;
  font-weight:400;
  line-height:1.5em;
  color:$secondaryColor;
  margin-bottom:20px;
  margin-right: 20%;
  max-width: 565px;
  margin-left:10%;
}

.banner h1 {
  padding-top:100px;
}

.banner-sep-container {
  width:60%;
  margin:20px auto 0 auto;
  max-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
}


.section-text p {
  font-size:18px;
  margin-bottom:30px;
  line-height: 1.5em;
}

.section-text {
  padding:0 5%;
}

.section-text p a {
  color:$mainColor;
}

.section-en {
  text-align: center;
  color:#fff;
  font-size: 20px;
}

.section-text p a:hover {
  text-decoration: underline;
  // color:$secondaryColor;
}

.section-cours .row {
  align-items: flex-start;
}

.section-img {
  max-width: 90%;
  height:auto;
  display: block;
  margin:0 auto;
}

.section-reverse .row, .section-reverse .title-container {
  flex-direction: row-reverse;
}

.section-reverse .title {
  margin-left: 0;
  margin-right: 2%;
}

.section-text h3 {
  font-size: 30px;
  line-height: 1.3em;
  margin-bottom: 20px;
}

.section-reverse .col-60  {
  margin-right:0;
  margin-left: 2%;
  justify-content: flex-end;
}

.section-program {
  background-image: url('./../assets/bg_seances.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding:80px 0;
}


.section-program h2 {
  color:#fff;
  text-align: center;
  margin-bottom:40px;
}

.section-program h2 span {
  margin:0;
}

.section-reverse .col-60.col-video {
  display: flex;
  justify-content: center;
}


.section-cours {
  
  padding-top:80px
}

.section-center h1 {
  text-align: center;
}

.section-center h2 {
  text-align: center;
  margin-bottom:40px;
}

.section-contact {
  background-image: url('./../assets/bg_contact.jpg');
  background-position: center ;
  background-repeat: no-repeat;
  background-size: cover;
  padding-top:80px;
  padding-bottom:80px;
}

.section-contact h2 {
  margin-bottom: 0;
  
}



.section-contact p {
  text-align: center;
  max-width: 90%;
  margin:0 auto 40px auto;
  font-size:20px;
  color:#000;
}

.insta-container {
  display:flex;
  flex-direction: column;
  align-items: center;
  width:100%;
}

.insta-sep {
  width:500px;
  max-width: 90%;
  height:2px;
  background:$textColor;
  margin-bottom: 20px;
}

.insta-item {
  display: flex;
  justify-content: center;
  align-items: center;
}



.insta-link:hover {
  color:$mainColor;
}

.insta-icon {
  height:30px;
  width:30px;
  min-width: 30px;
  background-image: url('./../assets/insta-icon.png');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-right:20px;
}

.section-book .col-img {
  display: flex;
  justify-content: center;
}

.section-book .col-text {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.section-book p {
  font-size:30px;
  color:$textColor;
  text-align: center;
  font-weight: 400;
  margin-bottom:0;
}

.section-book h1 {
  color:$textColor;
  font-size:60px;
  margin-bottom:20px;
}

.btn {
    background:$textColor;
    padding:5px 30px;
    border-radius:25px;
    text-decoration: none;
    font-size:15px;
    color:#fff;;
    border:1px solid $textColor;
    transition: 0.5s;
    cursor: pointer;
    margin:0 10px;
}

.btn:hover {
  background:#fff;
  color:$textColor;
}

p.opening {
  margin-top:40px;
  font-family: 'Allison', cursive;
  font-weight:200;
  font-size:40px;
  text-align: center;
}

video {
  max-width: 100%;
}

@media screen and (max-width:1200px){
  .banner h1 {
    padding-top:150px;
  }

  .banner h1, .banner p {
    margin-right: 10%;
  }

}

@media  screen and (max-width:768px) {
  .title-sep {
    display: none;
  }

  .title {
    width:100%;
    margin:0;
  }

  .banner h1, .banner p {
    font-size:18px;
    margin:0 0 20px 0;
  }

  h2 {
    font-size:25px;
    text-align: center;
  }

  .row {
    flex-direction: column;
    margin-bottom:40px;
  }

  .col-60, .col-40, .col-50 {
    width:100%;
    margin:0;
  }

  .section-img {
    margin-bottom:40px;
    display: block;
  }

  .section-text {
    padding:0;
  }

  .section-text p {
    font-size:18px;
  }

  .section-reverse .row {
    flex-direction: column;
  }

  .title-container {
    margin:40px 0;
  }

  .section-cours, .section-center {
    padding:0;
  }

  .banner {
    flex-direction: column-reverse;
    height:auto;
  }

  .col-banner {
    width:100%;
    height:300px;
    background-position: center;
    background-size: cover;
    min-height: auto;
  }

  .col-text {
    width:calc(100% - 40px);
    padding:80px 20px;
    height:auto;
    min-height: auto;;
  }

  .banner-text {
    width:100%;
  }

  .banner p {
    font-size:18px;
  }

  .banner p.opening {
    font-size:30px;
  }

  .section-contact {
    padding:40px 0;
  }

  .section-contact  p {
    font-size:15px;
  }

  .section-cours {
    background-image: none;
    padding-top:80px;
  }

  .insta-item {
    flex-direction: column;
    align-items: center;
  }

  .insta-icon {
    margin-bottom: 10px;
    margin-right: 0;
  }

  .section-book h1 {
    font-size:40px;
  }

  h2 span {
    margin:0;
  }
}

</style>
